import React from 'react';
import { History } from 'history';
import { Input, InputFile, InputNumber, InputMultiline, InputSelect, Layout, InputSwitch, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './report-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import ReportList from './report-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class ReportEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onChange(fieldName: string, value?: string) { 
        var  option = this.state.datarow.option;
        if (fieldName==='type' && !this.state.datarow.parent && value) option = Model.option[value];        
        
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, option: option,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} caption={this.state.datarow.parent && 'Edit ' +Model.caption+ ' Section'}
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError} disableCard>              

                <Layout history={this.props.history} direction={this.state.datarow.parent? 'column' : 'row'} content={[
                    {caption: 'Details', child: 
                    <>
                    <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                    <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                    <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                    {AppService.isAppFullVersion() &&
                    <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                        <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                    </InputPicklist> 
                    }
                    {this.state.datarow.parent &&
                    <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                    }
                    <Input name='title' label='Title' value={this.state.datarow.title} error={this.state.errors?.title} onChange={this.onChange} />
                    <InputMultiline name='content' label='Content' value={this.state.datarow.content} error={this.state.errors?.content} onChange={this.onChange} />
                    <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                    <InputSelect name='type' label='Type' value={this.state.datarow.type} options={this.state.datarow.parent? Model.optionTypeSection : Model.optionType} error={this.state.errors?.type} onChange={this.onChange} />
                    <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                    <Input name='imagetitle' label='Image Title' value={this.state.datarow.imagetitle} error={this.state.errors?.imagetitle} onChange={this.onChange} />
                    </>
                    },

                    {caption: 'Sections', hide: this.state.datarow.parent > 0, child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <ReportList history={this.props.history} root={this.props.root} caption='Report Section' parentId={this.state.datarow.id} disableBackButton disableCard/>
                    },

                    ]}
                    
                /> 

            </BaseEdit>
        );
    }
}